import React, {useState, useEffect } from 'react'
import request_logs from '../../API/API_Requests';
import axios_instance from '../../API/Axios';
import './Banner.css'

function Banner() {
    const [poster, setPoster] = useState([])

    useEffect(() => {
         async function fetchData() {
            const req = await axios_instance.get(request_logs.requests.fetch_N_Orignals)
            // console.log(req.data.results);
            setPoster(
                req.data.results[Math.floor(Math.random() * req.data.results.length - 1)]
            );
            return req;
         }
         fetchData();
    },[])

    function truncate(str, n){
        return str?.length > n ? str.substr(0, n-1) + '...' : str;
    }

    return (
        <header className="banner"
                style={{
                    backgroundSize: 'cover',
                    backgroundImage: `url("https://image.tmdb.org/t/p/original/${poster?.backdrop_path}")`,
                    backgroundPosition: 'center center'
                }}
        >{/* << background image >> */}

        <div className="banner_contents">
            {/* title */}
            <h1 className="banner_title">{poster?.title || poster?.name || poster?.orignal_name}</h1>

            {/* div > 2 buttons */}
            <div className="banner_buttons">
                <button className="banner_button">Play</button>
                <button className="banner_button">My List</button>
            </div>

            {/* description */}
            <h1 className="banner_desciption">
                {truncate(poster?.overview, 140)}
            </h1>
        </div>

        <div className="banner_fadeBottom">

        </div>
        </header>
    )
}

export default Banner
